import { useQuery } from '@tanstack/react-query';

import { getOrganizationSummary } from '@/modules/common/api/organization.api';

export const ORGANIZATION_SUMMARY_QUERY_KEY = ['organization-summary'];

const STALE_TIME = 1000 * 60 * 30; // 30 minutes

export const useOrganizationSummary = () => {
  return useQuery({
    queryKey: ORGANIZATION_SUMMARY_QUERY_KEY,
    queryFn: getOrganizationSummary,
    staleTime: STALE_TIME,
  });
};
